import { liveConversations, type Conversation } from '../scenarios';

interface QuestionChipsProps {
  disabled: boolean;
  onPick: (conversation: Conversation) => void;
}

interface CategoryGroup {
  category: string;
  items: Conversation[];
}

function groupByCategory(): CategoryGroup[] {
  const groups: CategoryGroup[] = [];
  for (const conversation of liveConversations) {
    let group = groups.find((g) => g.category === conversation.category);
    if (!group) {
      group = { category: conversation.category, items: [] };
      groups.push(group);
    }
    group.items.push(conversation);
  }
  return groups;
}

const groups = groupByCategory();

/** Suggested-question chips for the „Нов чат“ empty state, grouped by category. */
export const QuestionChips = ({ disabled, onPick }: QuestionChipsProps): JSX.Element => (
  <div className="w-full max-w-xl space-y-4">
    {groups.map((group) => (
      <div key={group.category}>
        <h3 className="mb-1.5 text-xs font-medium uppercase tracking-wide text-neutral-400">
          {group.category}
        </h3>
        <div className="flex flex-wrap gap-1.5">
          {group.items.map((conversation) => (
            <button
              key={conversation.id}
              type="button"
              disabled={disabled}
              onClick={() => onPick(conversation)}
              title={(conversation.steps[0] as { content?: string }).content}
              className="rounded-full border border-neutral-200 bg-white px-3 py-1.5 text-sm text-neutral-600 transition-colors hover:border-blue-300 hover:text-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {conversation.label}
            </button>
          ))}
        </div>
      </div>
    ))}
  </div>
);
